import { differenceInDays } from "date-fns";

export const generateCopiableName = (rsk_ref, embarcador, nave, voyage_number, bl_awb, container, puerto_origen, puerto_destino, reclamo_usd, reclamo_euros, moneda = "$") => {
    //console.log("generateCopiableName - moneda", moneda);
    //console.log("generateCopiableName - reclamo_euros", reclamo_euros);
    let monedaDisplay = '$';
    let amountDisplay = null;

    if (moneda){
        if (moneda === "EUR"){
            monedaDisplay = "EUR";
            amountDisplay = reclamo_euros;
        } else {
            monedaDisplay = "USD";
            amountDisplay = reclamo_usd;
        }
    } else {
        if (reclamo_euros){
            monedaDisplay = "EUR";
            amountDisplay = reclamo_euros;
        } else {
            monedaDisplay = "USD";
            amountDisplay = reclamo_usd;
        }
    }
    const bl_awb_cleaned = bl_awb ? bl_awb.replace(/-/g, '') : "N/A";
    return `${rsk_ref.replace(/\//g, '-') || "N/A"} / ${embarcador || "N/A"} / ${nave || "N/A"} /${voyage_number ? ` Voyage Number: ${voyage_number} /` : ""} ${bl_awb_cleaned} / ${container || "N/A"} / POL: ${puerto_origen || "N/A"} / POD: ${puerto_destino || "N/A"} / Claim Amount: ${monedaDisplay} ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amountDisplay || 0)}`;
}

/**
 * Calcula Time Bar (Fecha de arribo + 730 días)
 * @param {string|Date} fechaArribo - Fecha de arribo
 * @param {boolean} toString - Si true, devuelve la fecha en formato ISO
 * @returns {Date|null} - Time Bar calculado o null
 */
export const calcularTimeBar = (fechaArribo, toString = false) => {
    if (!fechaArribo) return null;
    
    const fechaArriboDate = new Date(fechaArribo);
    if (isNaN(fechaArriboDate.getTime())) return null;
    
    // Crear fecha en UTC para evitar problemas de zona horaria
    const fechaArriboUTC = new Date(Date.UTC(
        fechaArriboDate.getUTCFullYear(),
        fechaArriboDate.getUTCMonth(),
        fechaArriboDate.getUTCDate()
    ));
    
    // Sumar 730 días en UTC
    fechaArriboUTC.setUTCDate(fechaArriboUTC.getUTCDate() + 730);
    
    if (toString) {
        const day = String(fechaArriboUTC.getUTCDate()).padStart(2, '0');
        const month = String(fechaArriboUTC.getUTCMonth() + 1).padStart(2, '0');
        const year = fechaArriboUTC.getUTCFullYear();
        return `${day}-${month}-${year}`;
    } else {
        return fechaArriboUTC;
    }
};

/**
 * Calcula los días que faltan basándose en Time Extension o Time Bar
 * @param {string|Date} timeExtension - Time Extension
 * @param {string|Date} fechaArribo - Fecha de arribo
 * @returns {string} - Días que faltan o "Vencido" o "N/A"
 */
export const calcularDiasQueFaltan = (timeExtension, fechaArribo) => {
    const hoy = new Date();
    hoy.setUTCHours(0, 0, 0, 0); // Resetear a inicio del día UTC para comparación precisa
    
    let fechaReferencia = null;

    // Prioridad 1: Si existe time_extension, usarla como fecha de referencia
    if (timeExtension) {
        fechaReferencia = new Date(timeExtension);
    }
    // Prioridad 2: Si no hay time_extension, calcular time_bar desde fecha_arribo + 730
    else if (fechaArribo) {
        const timeBarCalculado = calcularTimeBar(fechaArribo);
        if (timeBarCalculado) {
            fechaReferencia = timeBarCalculado;
        }
    }

    if (!fechaReferencia || isNaN(fechaReferencia.getTime())) {
        return "N/A";
    }

    // Crear fechas en UTC usando solo la fecha (ignorar hora)
    const fechaReferenciaUTC = new Date(Date.UTC(
        fechaReferencia.getUTCFullYear(), 
        fechaReferencia.getUTCMonth(), 
        fechaReferencia.getUTCDate()
    ));
    const hoyUTC = new Date(Date.UTC(
        hoy.getUTCFullYear(), 
        hoy.getUTCMonth(), 
        hoy.getUTCDate()
    ));
    
    const diasDiferencia = differenceInDays(fechaReferenciaUTC, hoyUTC);

    // Si es negativo o cero, está vencido
    if (diasDiferencia <= 0) {
        return "Expired";
    } else {
        return diasDiferencia.toString();
    }
};